import { Box } from "@mui/material";
import { useCommonCmpasModuleListQuery } from "@app/api/carApi.generated";
import { useDialog } from "@app/hooks/useDialog";
import { AddRowButton, CarButton } from "@app/components/Buttons";
import { CarGrid } from "@app/components/Grid";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import { CarIconCheck } from "@app/components/Icons";
import { getNextSortOrder } from "@app/utils";
import { ModuleEditorDialog } from "./ModuleEditorDialog";

export const SettingsBackendModules = () => {
  const modules = useCommonCmpasModuleListQuery();

  const items = modules.data ?? [];

  const dialog = useDialog();

  const handleEditModule = (params: {
    id?: string;
    nextSortOrder?: number;
  }) => {
    dialog(ModuleEditorDialog, params);
  };

  return (
    <TablePlaceHolder isLoading={modules.isLoading} rows={8}>
      <AddRowButton
        sx={{
          mt: 2,
          ml: -1,
          alignSelf: "flex-start",
        }}
        onClick={() =>
          handleEditModule({ nextSortOrder: getNextSortOrder(items) })
        }
      >
        Add Module
      </AddRowButton>
      <CarGrid
        headerSx={{ mt: 3, mb: 0.5 }}
        isWhiteContext
        rows={items}
        columns={[
          {
            fraction: 1,
            label: "Name",
            field: "name",
          },
          {
            label: "Code",
            field: "code",
          },
          {
            fraction: 1.5,
            label: "Description",
            field: "description",
          },
          {
            fraction: "120px",
            label: "Is Active",
            field: "is_active",
            textAlign: "center",
            headerAlign: "center",
            onCellRender: (row) => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {row.is_active && <CarIconCheck sx={{ color: "green" }} />}
              </Box>
            ),
          },
          {
            label: "",
            fraction: "120px",
            onCellRender: (row) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    py: 1,
                  }}
                >
                  <CarButton
                    sx={{
                      width: 100,
                      height: 40,
                    }}
                    onClick={() => row.id && handleEditModule({ id: row.id })}
                  >
                    Edit
                  </CarButton>
                </Box>
              );
            },
          },
        ]}
      />
    </TablePlaceHolder>
  );
};
